import { render, staticRenderFns } from "./ReturnlyWebhooks.vue?vue&type=template&id=6ec7edc6"
import script from "./ReturnlyWebhooks.vue?vue&type=script&lang=js"
export * from "./ReturnlyWebhooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports